import VueRouter from 'vue-router';
import Calendar from './components/Calendar.vue';
import Stats from './components/Stats.vue';
import EmbedCodes from './components/EmbedCodes.vue';
import Colors from './components/Colors.vue';
import Users from './components/Users.vue';
import EditAccount from './components/EditAccount.vue';
import Login from './components/Login.vue';
import Register from './components/Register.vue';

export default new VueRouter({
	linkActiveClass: 'is-active',
	routes: [
		{
			path: '/',
			component: Calendar
		},
		{
			path: '/stats',
			alias: '/Statistiken',
			component: Stats
        },
        {
			path: '/embed-codes',
			alias: '/Codes',
			component: EmbedCodes
		},
		{
			path: '/colors',
			alias: '/Farben',
			component: Colors
		},
		{
			path: '/users',
			alias: '/Benutzer',
			component: Users
		},
		{
			path: '/users/settings',
			alias: '/Benutzer/Einstellungen',
			component: EditAccount
        },
        {
            path: '/login',
            alias: '/Anmelden',
            component: Login
        },
        {
            path: '/register',
            alias: '/Registrieren',
            component: Register
        }
	]
});
